import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/imports')({
  staticData: {
    permissionSection: 'settings',
    breadcrumb: 'Work Order Imports',
    layout: 'default',
  },
  component: () => <Outlet />,
});
